export const SITE = {
  name: "ClearView",
  fullName: "ClearView Pressure Washing",
  phone: "(234) 233-9716",
  phoneHref: "tel:+12342339716",
  email: "Clearviewpressure18@gmail.com",
  area: "Ohio",
  rating: 5.0,
  reviewCount: 150,
  reviewCountLabel: "150+",
  hours: [
    { day: "Mon – Fri", time: "8:00 AM – 7:00 PM" },
    { day: "Saturday", time: "9:00 AM – 5:00 PM" },
    { day: "Sunday", time: "By Appointment" },
  ],
};

export const SERVICES = [
  {
    id: "house-washing",
    title: "House Washing",
    short: "Soft wash siding, brick & vinyl",
    description:
      "A gentle, low-pressure soft wash that lifts mildew, algae, dust, and cobwebs from siding, brick, stucco, and vinyl — without damaging paint or seals.",
    bullets: [
      "Soft-wash detergent system",
      "Safe for plants & pets",
      "Removes mildew & algae",
      "1–3 hour turnaround",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/he7zbgrn_IMG_4176.jpeg",
  },
  {
    id: "driveway-washing",
    title: "Driveway Washing",
    short: "Concrete, pavers & walkways",
    description:
      "Surface-cleaner restoration for driveways, sidewalks, patios, and pool decks. We lift oil stains, tire marks, mildew, and years of grime.",
    bullets: [
      "Surface cleaner finish",
      "Removes oil & rust",
      "Joint-safe pressure",
      "Restores curb appeal",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/8ae63v24_IMG_4196.jpeg",
  },
  {
    id: "gutter-cleaning",
    title: "Gutter Cleaning",
    short: "Inside-out gutter & downspout",
    description:
      "Clogged gutters cause foundation damage. We hand-clear, flush, and brighten the exterior face of your gutters so water moves where it should.",
    bullets: [
      "Hand-clear debris",
      "Flush downspouts",
      "Exterior brightening",
      "Free leak inspection",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/7mgiof11_IMG_4378.jpeg",
  },
];

export const REVIEWS = [
  { name: "Sarah M.", initials: "SM", text: "Our siding looked like new after Mike's team finished. They were on time, polite, and extremely thorough. Worth every penny.", city: "Akron, OH" },
  { name: "Daniel R.", initials: "DR", text: "Best driveway cleaning I have ever paid for. Oil stains I had given up on are gone. Booking was easy and the quote was honest.", city: "Canton, OH" },
  { name: "Jennifer P.", initials: "JP", text: "Gutters were a mess after the storms. ClearView came out the next morning and cleared everything plus brightened the exterior. Perfect.", city: "Cleveland, OH" },
  { name: "Marcus T.", initials: "MT", text: "Professional from the first phone call. They protected the landscaping and treated the algae spots. House looks five years younger.", city: "Massillon, OH" },
  { name: "Alicia K.", initials: "AK", text: "Quick, affordable, and the result is incredible. The whole back patio looks brand new. Already booked them for next year.", city: "Wooster, OH" },
  { name: "Greg L.", initials: "GL", text: "Honest pricing, no upsell, and incredible work. They explained the soft-wash process before starting. Highly recommend.", city: "Medina, OH" },
  { name: "Tasha W.", initials: "TW", text: "We had green mold on the north side of the house for years. One visit and it is completely gone. Friendly crew too.", city: "Stow, OH" },
  { name: "Robert H.", initials: "RH", text: "I manage a few rentals and ClearView is now my go-to. Reliable, fast, and turns a tired property into a leasable one.", city: "Barberton, OH" },
  { name: "Emily S.", initials: "ES", text: "Showed up on time, did exactly what was quoted, and cleaned up after themselves. Best service experience I have had this year.", city: "Hudson, OH" },
  { name: "Carlos V.", initials: "CV", text: "Driveway, sidewalk and porch — all done in under three hours and looking incredible. Will absolutely use again.", city: "North Canton, OH" },
  { name: "Priya N.", initials: "PN", text: "I was nervous about pressure on our older siding. They used the soft-wash method and it came out flawless.", city: "Cuyahoga Falls, OH" },
  { name: "Brian O.", initials: "BO", text: "Quoted me over text within an hour, came out two days later. Fair price, fantastic outcome.", city: "Tallmadge, OH" },
  { name: "Linda F.", initials: "LF", text: "They cleaned our gutters and noticed a small leak we hadn't seen — saved us a real headache. Above and beyond.", city: "Green, OH" },
  { name: "Kevin D.", initials: "KD", text: "Customer service is what sets them apart. They actually called the next day to make sure I was happy.", city: "Fairlawn, OH" },
  { name: "Monica B.", initials: "MB", text: "Five stars without a doubt. The exterior of our home is the best it has ever looked since we moved in.", city: "Bath, OH" },
];

export const GALLERY = [
  // Real before/afters from ClearView jobs
  { src: "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/y6nmfb3q_IMG_4175.jpeg", label: "Before" },
  { src: "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/he7zbgrn_IMG_4176.jpeg", label: "After" },
  { src: "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/jw3p94xn_IMG_4195.jpeg", label: "Before" },
  { src: "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/8ae63v24_IMG_4196.jpeg", label: "After" },
  { src: "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/aimy9eyc_IMG_4194.jpeg", label: "Finished" },
  { src: "https://images.pexels.com/photos/4469156/pexels-photo-4469156.jpeg", label: "Curb appeal" },
];
